import {
  apiReportingPost,
  apiReportingGet,
  apiReportingPut,
  apiReportingDelete,
} from '../utils/api'
import Hotjar from '@hotjar/browser'

export const getUrlToBlazeInsightsAPI = () => {
  return apiReportingGet(`insights/redirect`)
}

export const getBroadcastsAPI = () => {
  return apiReportingGet(`insights/broadcast`)
}

export const createBroadcastAPI = (data) => {
  Hotjar.event('create_boradcast')
  return apiReportingPost(`insights/broadcast`, data)
}

export const updateBroadcastAPI = (broadcastId, data) => {
  Hotjar.event('update_broadcast')
  return apiReportingPut(`insights/broadcast/${broadcastId}`, data)
}

export const deleteBroadcastAPI = (broadcastId) => {
  Hotjar.event('delete_bradcast')
  return apiReportingDelete(`insights/broadcast/${broadcastId}`)
}

export const getDropdownsAPI = () => {
  return apiReportingGet(`insights/broadcast/dropdowns`)
}

export function getAvailableReportsAPI() {
  return apiReportingGet(`mgmt/reporting/list?app=AuthenticationApp`)
}

export function getReportRequestListAPI() {
  return apiReportingGet('mgmt/reporting/reportrequest/list?isMultishop=true')
}

export function getGeneratedReportAPI(requestId, assetToken) {
  return apiReportingGet(
    `mgmt/reporting/generated/${requestId}?assetToken=${assetToken}`,
    {},
    {},
    {},
    false,
    'arraybuffer',
  )
}

export function exportByReportTypeAPI(
  reportType,
  filterDate,
  startDate,
  endDate,
  shopIds,
  version,
  format,
) {
  return apiReportingGet(
    `insights/report/export?type=${reportType}&filterDate=${filterDate}&startDate=${startDate}&endDate=${endDate}&shopIds=` +
      encodeURIComponent(shopIds) +
      `&version=${version}&format=${format}`,
  )
}

export function getBroadcastDropdownsInfoAPI() {
  return apiReportingGet('insights/broadcast/dropdowns')
}

export function syncInsightsPermissionsAPI(employeeId) {
  return apiReportingPost(`insights/syncPermissionsWithYellowfin?employeeId=${employeeId}`)
}



// WEBPACK FOOTER //
// ./src/api/insights.js